<ion-app>
  <ion-router-outlet></ion-router-outlet>
  @if (homologacao) {
    <div id="navbar-homolog">HOMOLOGAÇÃO</div>
  }
</ion-app>
